import { Divider, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography, useMediaQuery } from '@mui/material';
import React, { useState } from 'react'
import contactStyle from "../../../../../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss";
import dashboardStyles from '../../../../../../assets/styles/componentStyles/callAnalysisStyles/callAnalysisDashboard.module.scss';
import globalStyles from "../../../../../../assets/styles/global.module.scss";
import styles from "../../../../../../assets/styles/componentStyles/chatbotStyles/chats.module.scss";
import CopyToClipboard from 'react-copy-to-clipboard';
import IconsColor from '../../../../../../components/utility/iconsColor';
import { fontColorForAwaitWebhook } from '../../../../../../utils/constants';

interface WebhookActionLogPopupProps {
    actionData: any,
} 

const WebhookActionLogPopup: React.FC<WebhookActionLogPopupProps> = (props) => {
    
    const { actionData } = props;
    const flagTabletScreen = useMediaQuery('(min-width: 0px) and (max-width: 768px)');
    const flagLaptopScreen = useMediaQuery('(min-width: 0px) and (max-width: 1000px)');

    const [copyText, setCopyText] = useState<string>("Copy");
    const innerHeight = window.innerHeight - 150;
    const innerTableHeight = 500;
    
    return (
        <>
            <Grid item xs={12}>
                <Grid container direction={"column"} justifyContent={"center"}>
                    <Grid item textAlign={"center"}>
                        <Typography className={contactStyle.popupTitleTypography}>Await Webhook Log</Typography>
                    </Grid> 

                    <Divider className={contactStyle.popupTitleDivider} /> 

                    <Grid item>
                        <Grid container className={`${contactStyle.popupBodyGridContainer} ${styles.customAPILogsManiContainer}`} gap={2} sx={{ maxHeight: `${innerHeight}px !important`}}>
                            
                            <Grid item xs={12}>
                                <Grid container gap={"10px"} alignItems={"center"} flexWrap={flagTabletScreen ? "wrap" : "nowrap"}>

                                    <Grid item className={`${styles.customAPILogsInformation} ${styles.customAPIStatusCodeInfo}`}>
                                        <Grid container alignItems={"center"} gap={"5px"} flexWrap={"nowrap"}>
                                            <Grid item className={styles.customAPILogsTitle}>Webhook URL</Grid>
                                            <span className={`${styles.customAPILogsValue}`}>{actionData?.expected_webhook_url || "-"}</span> 
                                             <CopyToClipboard text={actionData?.expected_webhook_url || "-"}>
                                                <Tooltip
                                                    placement="bottom"
                                                    title={copyText}
                                                    onMouseLeave={() => setCopyText("Copy!")}
                                                    onClick={() => {
                                                        setCopyText("Copied!");
                                                    }}
                                                >
                                                <Grid item className={styles.copyURlIcon}>
                                                    <IconsColor  iconName={"Copy"} fillColor={"black"} width={"16"} height={"16"} />
                                                </Grid>
                                                </Tooltip>
                                            </CopyToClipboard>
                                        </Grid>
                                    </Grid>
                                    
                                    <Grid item className={`${styles.customAPILogsInformation} ${styles.customAPIStatusCodeInfo}`}>
                                        <Grid container alignItems={"center"} gap={"5px"} flexWrap={"nowrap"}>
                                            <Grid item className={styles.customAPILogsTitle}>Company Name</Grid>
                                            <span className={`${styles.customAPILogsValue}`}>{actionData?.webhook_external_company_name || "-"}</span>
                                        </Grid>
                                    </Grid>
                                    
                                    <Grid item className={`${styles.customAPILogsInformation} ${styles.customAPIStatusCodeInfo}`}>
                                        <Grid container alignItems={"center"} gap={"5px"} flexWrap={"nowrap"}>
                                            <Grid item className={styles.customAPILogsTitle}>Status</Grid>
                                            <span className={`${styles.customAPILogsValue}`} style={{ color: actionData?.status ? fontColorForAwaitWebhook(actionData?.status) : "black"}}>{actionData?.status || "-"}</span>
                                        </Grid>
                                    </Grid>

                                </Grid>
                            </Grid>
                            
                            <Grid item xs={12}>
                                <Grid container gap={3} flexWrap={flagLaptopScreen ? "wrap" : "nowrap"}>
                                    <Grid item xs={flagLaptopScreen ? 12 : 6}>
                                        <Grid container gap={"12px"}>
                                            
                                            <Grid item xs={12}>
                                                <Grid container className={globalStyles.flexColumn} gap={1}>
                                                    <Grid item>
                                                        <Typography className={contactStyle.popupFieldTypography}>Identifier Fields</Typography>
                                                    </Grid>
                                                    <Grid item>
                                                        <TableContainer className={styles.customApiSaveVariableTableContainer} sx={{maxHeight: `${innerTableHeight}px !important`}}>
                                                            <Table stickyHeader>
                                                                <TableHead>
                                                                    <TableRow>
                                                                        <TableCell className={dashboardStyles.tableBodyHeadingFontStyle}>Field Path</TableCell>
                                                                        <TableCell className={dashboardStyles.tableBodyHeadingFontStyle}>Value</TableCell>
                                                                    </TableRow>
                                                                </TableHead>
                                                                <TableBody>
                                                                    {actionData?.identifier_fields && actionData?.identifier_fields?.length > 0 ?
                                                                        actionData?.identifier_fields?.map((field: any, ind: number) => {
                                                                            return (
                                                                                <TableRow className={dashboardStyles.cellRow} key={ind}>
                                                                                    <TableCell className={dashboardStyles.tableBodySubHeadingFontStyle}>{field?.identifier_field_path || "-"}</TableCell>
                                                                                    <TableCell className={dashboardStyles.tableBodySubHeadingFontStyle}>{field?.identifier_field_value || "-"}</TableCell>
                                                                                </TableRow>
                                                                            );
                                                                        })
                                                                        :
                                                                        <TableRow className={dashboardStyles.cellRow}>
                                                                            <TableCell colSpan={12} className={globalStyles.textCenter}>
                                                                                No Data Available
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    }
                                                                </TableBody>
                                                            </Table>
                                                        </TableContainer>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                                    
                                            <Grid item xs={12}>
                                                <Grid container className={globalStyles.flexColumn} gap={1}>
                                                    <Grid item>
                                                        <Typography className={contactStyle.popupFieldTypography}>Save Variable Fields</Typography>
                                                    </Grid>
                                                    <Grid item>
                                                        <TableContainer className={styles.customApiSaveVariableTableContainer} sx={{maxHeight: `${innerTableHeight}px !important`}}>
                                                            <Table stickyHeader>
                                                                <TableHead>
                                                                    <TableRow>
                                                                        <TableCell className={dashboardStyles.tableBodyHeadingFontStyle}>Variable</TableCell>
                                                                        <TableCell className={dashboardStyles.tableBodyHeadingFontStyle}>Value</TableCell>
                                                                    </TableRow>
                                                                </TableHead>
                                                                <TableBody>
                                                                    {actionData?.saved_variables && actionData?.saved_variables?.length > 0 ?
                                                                        actionData?.saved_variables?.map((variable: any, ind: number) => {
                                                                            return (
                                                                                <TableRow className={dashboardStyles.cellRow} key={ind}>
                                                                                    <TableCell className={dashboardStyles.tableBodySubHeadingFontStyle}>{variable?.chatbot_custom_variable_name || "-"}</TableCell>
                                                                                    <TableCell className={dashboardStyles.tableBodySubHeadingFontStyle}>{variable?.field_value || "-"}</TableCell>
                                                                                </TableRow>
                                                                            );
                                                                        })
                                                                        :
                                                                        <TableRow className={dashboardStyles.cellRow}>
                                                                            <TableCell colSpan={12} className={globalStyles.textCenter}>
                                                                                No Data Available
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    }
                                                                </TableBody>
                                                            </Table>
                                                        </TableContainer>
                                                    </Grid>
                                                </Grid>
                                            </Grid>

                                        </Grid>
                                    </Grid> 

                                    <Grid item xs={flagLaptopScreen ? 12 : 6}>
                                        <Grid container className={globalStyles.flexColumn} gap={1}>
                                            <Grid item xs={12}>
                                                <Typography className={contactStyle.popupFieldTypography}>Received Payload</Typography>
                                            </Grid> 
                                            <Grid item xs={12} className={globalStyles.relativePosition}>
                                                <pre className={`${styles.payloadResponsePreTag} ${styles.webhookReceivedPayloadPreTag}`}>
                                                    {JSON.stringify(JSON.parse(actionData?.json_received_payload), null, 4)}

                                                    <CopyToClipboard text={JSON.stringify(JSON.parse(actionData?.json_received_payload), null, 4)}>
                                                        <Tooltip
                                                            placement="bottom"
                                                            title={copyText}
                                                            onMouseLeave={() => setCopyText("Copy!")}
                                                            onClick={() => {
                                                                setCopyText("Copied!");
                                                            }}
                                                        >
                                                            <Grid item className={styles.copyIcon}>
                                                                <IconsColor  iconName={"Copy"} fillColor={"black"} width={"16"} height={"16"} />
                                                            </Grid>
                                                        </Tooltip>
                                                    </CopyToClipboard>
                                                </pre>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default WebhookActionLogPopup
